import { gql, useQuery } from '@apollo/client';

export const GET_CURRENT_PERMISSIONS_GROUP = gql`
  query getCurrentPermissionGroup {
    getCurrentPermission {
      _id
      permissions {
        permission
        rule
      }
    }
  }
`;

export const useGetCurrentPermissionGroup = () => {
  const { data } = useQuery(GET_CURRENT_PERMISSIONS_GROUP);
  const { _id: permissionGroupId, permissions = [], loading } = data?.getCurrentPermission || {};

  return { permissionGroupId, permissions, loading };
};
